import { AutoSizer, List, WindowScroller } from 'react-virtualized';

import useScreenSize from '@/hooks/useScreenSize';
import ArtlistCard from '@/shared-components/cards/components/ArtlistCard';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import './styles/ArtlistsVirtualList.css';

export default function ArtlistsVirtualList({ items, onLoadMore }) {
  const { width: screenWidth } = useScreenSize();

  return (
    <InfiniteScroll
      onLoadMore={onLoadMore}
      shouldLoadMore={items.data.length < items.totalDocs}
      offsetElements={3}
      listLength={items.data.length}
    >
      {({ infiniteScrollAssigner }) => (
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer disableHeight>
              {({ width }) => {
                // Match the search artlists grid, using the actual profile outlet width.
                const columnsPerRow = width <= 692 ? 2 : width <= 950 ? 3 : 4;
                const gap = screenWidth <= 600 ? 10 : 15;
                const columnWidth = Math.max(0, (width - (columnsPerRow - 1) * gap) / columnsPerRow);
                const rowHeight = columnWidth + gap; // Artlist covers are square.

                return (
                  <List
                    key={`${width}-${gap}`}
                    className="profile-artlists__list"
                    autoHeight
                    width={width || 0.1}
                    height={height}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    overscanRowCount={3}
                    rowCount={Math.ceil(items.data.length / columnsPerRow)}
                    rowHeight={rowHeight}
                    estimatedRowSize={rowHeight}
                    rowRenderer={({ index, key, style }) => {
                      const fromIndex = index * columnsPerRow;
                      const rowItems = items.data.slice(fromIndex, fromIndex + columnsPerRow);

                      return (
                        <div className="profile-artlists__artlists-virtual-row" key={key} style={style}>
                          <div
                            className="profile-artlists__artlists-grid"
                            style={{
                              gridTemplateColumns: `repeat(${columnsPerRow}, ${columnWidth}px)`,
                              columnGap: gap,
                            }}
                          >
                            {rowItems.map((item, columnIndex) => {
                              const itemIndex = fromIndex + columnIndex;
                              return (
                                <ArtlistCard
                                  key={item._id ?? itemIndex}
                                  data={item}
                                  style={{ width: `${columnWidth}px` }}
                                  infiniteScrollObserver={infiniteScrollAssigner(itemIndex)}
                                />
                              );
                            })}
                          </div>
                        </div>
                      );
                    }}
                  />
                );
              }}
            </AutoSizer>
          )}
        </WindowScroller>
      )}
    </InfiniteScroll>
  );
}
